import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function PreQue() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    role: '',
    salaryExpectation: '',
    consents: {
      timeConsent: false,
      proceedConsent: false
    }
  });
  const [error, setError] = useState('');

  const roles = [
    'Brand Partnership and Customer Onboarding',
    'Marketing, Sales and Customer Onboarding'
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setUserData({
        ...userData,
        consents: {
          ...userData.consents,
          [name]: checked
        }
      });
    } else {
      setUserData({
        ...userData,
        [name]: value
      });
    }
  };

  const validateAndProceed = () => {
    if (!userData.fullName || !userData.email || !userData.phoneNumber || !userData.role || !userData.salaryExpectation) {
      setError('Please fill in all required fields.');
      return;
    }

    if (!userData.consents.timeConsent || !userData.consents.proceedConsent) {
      setError('Please agree to all consent statements to proceed.');
      return;
    }

    setError('');
    // Store user data in sessionStorage for the protected route
    sessionStorage.setItem('preAssessmentUserData', JSON.stringify(userData));
    // Redirect to the Assessment component
    navigate('/Pre-Interview/assessment');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-10">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-lg">
        <div className="border-b border-gray-200 pb-4 mb-6">
          <h1 className="text-3xl font-bold text-center text-indigo-700">Fomerly HR Pre-Assessment</h1>
          <div className="w-24 h-1 bg-indigo-500 mx-auto mt-2"></div>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Welcome to the pre-assessment interview</h2>
          <p className="text-gray-600 mb-6">This assessment is designed to evaluate your suitability for the position. Please complete all questions honestly.</p>
          
          <div className="mb-6 p-5 bg-blue-50 rounded-lg border-l-4 border-blue-500 shadow-sm">
            <h3 className="font-bold text-lg text-blue-800 mb-3">Permission to Start</h3>
            <div className="flex items-start mb-3">
              <input
                type="checkbox"
                id="timeConsent"
                name="timeConsent"
                checked={userData.consents.timeConsent}
                onChange={handleInputChange}
                className="mt-1 mr-3 h-5 w-5 text-blue-600"
              />
              <label htmlFor="timeConsent" className="text-gray-700">
                I understand that this assessment is part of the pre-screening process and will take a maximum of <strong>10 minutes</strong>. Each question is timed, and must complete it in one sitting.
              </label>
            </div>
            <div className="flex items-start">
              <input
                type="checkbox"
                id="proceedConsent"
                name="proceedConsent"
                checked={userData.consents.proceedConsent}
                onChange={handleInputChange}
                className="mt-1 mr-3 h-5 w-5 text-blue-600"
              />
              <label htmlFor="proceedConsent" className="text-gray-700">
                I consent to proceed.
              </label>
            </div>
          </div>
        </div>
        
        {/* Grid layout for form fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Full Name<span className="text-red-500">*</span></label>
            <input 
              type="text" 
              name="fullName" 
              value={userData.fullName} 
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 focus:outline-none transition-all"
              placeholder="Enter your full name"
              required
            />
          </div>
          
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Email Address<span className="text-red-500">*</span></label>
            <input 
              type="email" 
              name="email" 
              value={userData.email} 
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 focus:outline-none transition-all"
              placeholder="Enter your email"
              required
            />
          </div>
          
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Phone Number<span className="text-red-500">*</span></label>
            <input 
              type="tel" 
              name="phoneNumber" 
              value={userData.phoneNumber} 
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 focus:outline-none transition-all"
              placeholder="Enter your phone number"
              required
            />
          </div>
          
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Which role are you applying for?<span className="text-red-500">*</span></label>
            <select 
              name="role" 
              value={userData.role} 
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 focus:outline-none transition-all bg-white"
              required
            >
              <option value="">Select a role</option>
              {roles.map((role, index) => (
                <option key={index} value={role}>{role}</option>
              ))}
            </select>
          </div>
          
          <div className="space-y-2 md:col-span-2">
            <label className="block font-medium text-gray-700">Salary Expectations<span className="text-red-500">*</span></label>
            <div className="mb-3 p-4 bg-gray-50 border border-gray-200 rounded-lg">
              <p className="text-gray-700">This role is fully a hybrid one but fully remote remote for now. The initial salary for this position is ₦100,000 Naira monthly. The salary will be adjusted based on performance and growth on a Quarterly or Annually basis and to be in line with economic conditions where we intend to have an in-person schedule.
                
                <br />
                <br />
                <strong>
                Are you comfortable with this salary, and what are your salary expectations as you grow with the company (this may include expected salarymaybe in 3 to 6 months of your employment, commission, benefits like health schemes, transportation allowance, internet etc) ?
                </strong></p>
            </div>
            <textarea 
              name="salaryExpectation" 
              value={userData.salaryExpectation} 
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 focus:outline-none transition-all h-24"
              placeholder="Describe your salary expectations"
              required
            ></textarea>
          </div>
        </div>
        
        {error && (
          <div className="mt-6">
            <p className="text-red-500 bg-red-50 p-3 rounded-lg border-l-4 border-red-500">{error}</p>
          </div>
        )}
        
        <div className="mt-8">
          <button 
            onClick={validateAndProceed} 
            className="w-full py-3 px-6 bg-gradient-to-r from-indigo-600 to-blue-700 text-white font-medium rounded-lg hover:from-indigo-700 hover:to-blue-800 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 shadow-md transform hover:-translate-y-1"
          >
            Proceed to Assessment
          </button>
        </div>
      </div>
    </div>
  );
}

export default PreQue;